<div style="margin: 0px;background-color: white;left: 0;top: -10px;width: 100%;height: 99%;overflow: hidden;">
    <!-- <div class="container">
        <img src="../../../../assets/images/MobitrixHome.gif" width="100%" height="100%">
        <button (click)="signIn()" class="btn global-button"> Sign in </button>
    </div> -->
</div>
